export function convertDocumentFormToQueryParams(variationId?: string) {
	let form: HTMLFormElement | null = document.querySelector('#document-form')
	if (!form) {
		return ''
	}
	let formData = new FormData(form)
	let queryParams = new URLSearchParams()
	for (let [key, value] of formData.entries()) {
		// @ts-ignore
		queryParams.append(key, value)
	}

	if (variationId) {
		queryParams.append('variationId', variationId)
	}

  console.log(Object.fromEntries(formData.entries()));

	return queryParams.toString()
}
